import { useEffect } from "react";
import { useAuthStore } from "@/features/auth/store/auth.store";

/** Visibility changes closer together than this refresh the user once. */
export const VISIBLE_REFRESH_INTERVAL_MS = 15_000;

/**
 * Re-read the signed-in user when the tab becomes visible, so a role switch
 * made on another device shows before this tab's next request. `refreshUser`
 * does nothing when no one is signed in.
 */
export function useRefreshUserOnVisible(): void {
	const refreshUser = useAuthStore((s) => s.refreshUser);

	useEffect(() => {
		let lastRefreshAt = Number.NEGATIVE_INFINITY;

		const onVisibilityChange = (): void => {
			if (document.visibilityState !== "visible") return;
			const now = Date.now();
			if (now - lastRefreshAt < VISIBLE_REFRESH_INTERVAL_MS) return;
			lastRefreshAt = now;
			void refreshUser();
		};

		document.addEventListener("visibilitychange", onVisibilityChange);
		return () => {
			document.removeEventListener("visibilitychange", onVisibilityChange);
		};
	}, [refreshUser]);
}
